import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { fetchAndActivate, getRemoteConfig } from "firebase/remote-config";
import { getStorage } from "firebase/storage";
import appConfig from "./app.json";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIR_API_KEY,
  authDomain: process.env.REACT_APP_FIR_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIR_DB_URL,
  projectId: process.env.REACT_APP_FIR_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIR_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIR_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIR_APP_ID,
  measurementId: process.env.REACT_APP_FIR_MEASURMENT_ID
};

const firebaseConfig_readchain = {
  apiKey: process.env.REACT_APP_FIR_API_KEY_2,
  authDomain: process.env.REACT_APP_FIR_AUTH_DOMAIN_2,
  databaseURL: process.env.REACT_APP_FIR_DB_URL_2,
  projectId: process.env.REACT_APP_FIR_PROJECT_ID_2,
  storageBucket: process.env.REACT_APP_FIR_STORAGE_BUCKET_2,
  messagingSenderId: process.env.REACT_APP_FIR_MESSAGING_SENDER_ID_2,
  appId: process.env.REACT_APP_FIR_APP_ID_2,
  measurementId: process.env.REACT_APP_FIR_MEASURMENT_ID_2
};

const firebaseConfig_reading_stage = {
  apiKey: process.env.REACT_APP_FIR_API_KEY_3,
  authDomain: process.env.REACT_APP_FIR_AUTH_DOMAIN_3,
  databaseURL: process.env.REACT_APP_FIR_DB_URL_3,
  projectId: process.env.REACT_APP_FIR_PROJECT_ID_3,
  storageBucket: process.env.REACT_APP_FIR_STORAGE_BUCKET_3,
  messagingSenderId: process.env.REACT_APP_FIR_MESSAGING_SENDER_ID_3,
  appId: process.env.REACT_APP_FIR_APP_ID_3,
  measurementId: process.env.REACT_APP_FIR_MEASURMENT_ID_3
};

const app = initializeApp(firebaseConfig);
const app_readchain = initializeApp(firebaseConfig_readchain, "readchain");
const app_reading_stage = initializeApp(
  firebaseConfig_reading_stage,
  "reading-stage"
);

const environment = appConfig.environment || "prod";

let db, auth, db_stage;

if (environment === "prod") {
  db = getFirestore(app); // Use prod Firestore
  auth = getAuth(app); // Use prod Auth
} else if (environment === "stage") {
  db = getFirestore(app_reading_stage); // Use prod Firestore
  db_stage = getFirestore(app_reading_stage); // Use stage Firestore
  auth = getAuth(app_reading_stage); // Use prod Auth
  // auth = getAuth(app_reading_stage); // Use stage Auth
} else {
  throw new Error(`Unknown environment: ${environment}`);
}

// Common Firebase services
const db_readchain = getFirestore(app_readchain);
const auth_readchain = getAuth(app_readchain);
const firebaseFunctions = getFunctions(app);
const firebaseRemoteConfig = getRemoteConfig(app);
const firebaseStorage = getStorage(app);
firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 0;
firebaseRemoteConfig.settings.fetchTimeoutMillis = 0;
fetchAndActivate(firebaseRemoteConfig);

export {
  auth,
  auth_readchain,
  db,
  db_stage,
  db_readchain,
  firebaseFunctions,
  firebaseRemoteConfig,
  firebaseStorage,
  app,
  app_readchain,
  app_reading_stage
};
